<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<el-form :inline="true" :model="formInline" class="user-search">
				<el-form-item label="所属门店：">
					<el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small" @change="inputChange">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="年月：">
					<el-date-picker v-model="dateStr" type="month" value-format="yyyy-MM" format="yyyy年MM月" placeholder="请选择年月" size="small" @change="handleDateChange"></el-date-picker>
				</el-form-item>
				<el-form-item label="收款内容：">
					<el-input v-model="formInline.content" placeholder="请输入收款内容" clearable size="small"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button v-if="btnPermission.viewPage" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				</el-form-item>
			</el-form>
			<STable :columns="columnsData" :data="listData" :loading="loading" border stripe>
				<template #monthStr>
					<el-table-column label="年月" width="100" align="center">
						<template #default="scope">{{ scope.row.year }}年{{ scope.row.month }}月</template>
					</el-table-column>
				</template>
				<el-table-column slot="customerInfo.name" align="center" label="顾客姓名" width="120">
					<template #default="scope">
						<el-link :underline="false" type="primary" @click="handleSelectOrderPage(scope.row)">
							{{ scope.row.customerInfo.name }}
						</el-link>
					</template>
				</el-table-column>
				<template #isHandled>
					<el-table-column label="是否处理" width="100" align="center">
						<template #default="scope">
							<el-tag v-if="scope.row.isHandled" type="success">已处理</el-tag>
							<el-tag v-else type="danger">未处理</el-tag>
						</template>
					</el-table-column>
				</template>
				<template #operation>
					<el-table-column label="操作" width="170" align="center" fixed="right">
						<template #default="scope">
							<el-button v-if="btnPermission.dealWith && !scope.row.isHandled" size="small" type="warning" class="el-icon-edit" @click="handleDealWithClick(scope.row)">处理</el-button>
						</template>
					</el-table-column>
				</template>
			</STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
		<!-- 处理问题记录 -->
		<el-dialog :visible.sync="dialogVisible" title="处理问题记录" style="width: 60%; margin: auto" append-to-body :close-on-click-modal="false">
			<span style="display: block; margin-bottom: 10px"><strong>处理结果:</strong></span>
			<el-input v-model="handleResult" placeholder="请输入处理结果" style="width: 100%" size="small" type="textarea" rows="3"></el-input>
			<template #footer>
				<span>
					<el-button icon="el-icon-close" size="small" @click="dialogVisible = false">取消</el-button>
					<el-button type="primary" icon="el-icon-finished" size="small" :loading="isSubmitting" @click="handleDealWithSubmit">确认</el-button>
				</span>
			</template>
		</el-dialog>

		<!-- 选择订单 -->
		<selectOrderPage ref="selectOrderPage"></selectOrderPage>
	</div>
</template>

<script>
import { GetProblemPayRecordPageList, HnadleProblemPayRecord } from "@/api/payApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import selectOrderPage from "@/views/baseData/customer/selectOrderPage.vue";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "问题支付记录"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			dateStr: "",
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				storeKeyId: "",
				customerKeyId: "",
				isHandled: null,
				year: 0,
				month: 0
			},
			storeList: [],
			userList: [],
			columnsData: [],
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					slot: "monthStr",
					label: "年月",
					isKeep: true,
					width: "160",
					align: "center",
				},
				{
					prop: "storeName",
					label: "门店名称",
					isKeep: true,
					width: "160",
					align: "center",
				},
				{
					slot: "customerInfo.name",
					label: "顾客名称",
					isKeep: true,
					width: "100",
					align: "center",
				},
				{
					prop: "customerInfo.phone",
					label: "顾客电话",
					isKeep: true,
					width: "140",
					align: "center",
				},
				{
					prop: "count",
					label: "收款次数",
					width: "100",
					align: "center"
				},
				{
					prop: "content",
					label: "问题描述",
					minWidth: "300",
					align: "center"
				},
				{
					slot: "isHandled",
					label: "是否处理",
					width: "100",
					align: "center"
				},
				{
					prop: "handleUserName",
					label: "处理人",
					width: "120",
					align: "center"
				},
				{
					prop: "handleTime",
					label: "处理时间",
					minWidth: "160",
					align: "center"
				},
				{
					prop: "handleRemark",
					label: "处理结果",
					minWidth: "260",
					align: "center"
				},
				{
					prop: "creator",
					label: "经办人",
					width: "120",
					align: "center"
				},
				{
					prop: "createTime",
					label: "经办时间",
					width: "170",
					align: "center"
				},
				{
					slot: "operation",
					label: "操作",
					width: "170",
					align: "center",
					fixed: "right"
				}
			],
			btnPermission: {
				viewPage: false,
				dealWith: false
			},
			// 处理问题记录
			dialogVisible: false,
			handleResult: "",
			handlePayRecordId: "",
			isSubmitting: false
		};
	},
	// 注册组件
	components: {
		selectOrderPage
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.GetOrgInfoListByConfig();
		this.getBtnPermission();
		this.getListData();
	},
	computed: {},
	methods: {
		getBtnPermission() {
			this.btnPermission.viewPage = this.$checkBtnPermission("/pay/problem", "viewPage");
			this.btnPermission.dealWith = this.$checkBtnPermission("/pay/problem", "dealWith");
		},
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changePages() {},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						if (res.code == 1) {
							res.data.forEach((item) => {
								this.storeList.push({
									keyId: item.keyId,
									value: item.name + "【" + item.remark2 + "】"
								});
							});
						} else {
							this.$message.error(res.msg);
						}
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		// 获取列表
		getListData() {
			if (!this.btnPermission.viewPage) {
				this.$message.error("您没有权限查看问题记录！");
				return;
			}
			this.loading = true;
			GetProblemPayRecordPageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 日期选择器事件
		handleDateChange(val) {
			if (val) {
				var list = val.split("-");
				this.formInline.year = Number(list[0]);
				this.formInline.month = Number(list[1]);
			} else {
				this.formInline.year = 0;
				this.formInline.month = 0;
			}
			this.search();
		},
		handleDealWithClick(row) {
			if (!this.btnPermission.dealWith) {
				this.$message.error("您没有权限处理问题记录！");
				return;
			}
			this.handlePayRecordId = row.keyId;
			this.handleResult = "";
			this.dialogVisible = true;
		},
		handleDealWithSubmit() {
			if (!this.handleResult) {
				this.$message.error("请输入处理结果！");
				return;
			}
			this.$confirm("确认处理问题记录吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				HnadleProblemPayRecord({
					keyId: this.handlePayRecordId,
					handleRemark: this.handleResult
				}).then((res) => {
					if (res.code == 1) {
						this.$message({
							type: "success",
							message: "处理成功！"
						});
						this.dialogVisible = false;
						this.getListData();
					} else {
						this.$message.error(res.msg);
					}
				});
			});
		},
		// 选择订单
		handleSelectOrderPage(row) {
			this.$refs.selectOrderPage.showSelectOrderDialog(row.customerInfo.keyId);
		}
	}
};
</script>

<style scoped></style>
